<div class="container">
  <div class="country">
    <div class="country-breadcrumbs">
      <a href="" class="country-breadcrumb">
        BusyFly /
      </a>
      <div class="country-breadcrumb">
        {{name}}
      </div>
    </div>

    <div class="country-body">
      <div class="country-container">
        <div class="country-text-container">
          <div class="section-title">
            {{name}}
          </div>
          <div class="country-description">
            Для просмотра документа выберете интересующую вас страну
          </div>
        </div>
        <div class="country-list">
          <ng-container *ngFor="let country of countries">
            <a class="country-item" href="../../../{{country.docHref}}">
              <img class="country-item-img" src="../../../assets/img/countries/{{country.img}}" alt="ru">
              <div class="country-item-title">
                {{country.countryName}}
              </div>
            </a>
          </ng-container>
        </div>
      </div>
      <div class="country-img-container">
        <img id="cloud" class="cloud-group" src="../../../assets/img/clouds/cloud-group-2.svg" alt="image">
        <img class="country-img" src="../../../assets/img/books-image.svg" alt="image">
      </div>
    </div>
    <div class="country-button-container">
      <a href="/" class="button">
        Главная страница
      </a>
    </div>
  </div>
</div>
